import { grey400 } from 'material-ui/styles/colors';

const styles = {
    toggle: {
        marginBottom: '10px'
    },
    errorStyle: {
        color: grey400
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/common/UserSetting/UserSetting.css.js